import { PropsWithChildren } from "react";

function TemplateFrame({ children }: PropsWithChildren) {
  return <div className="w-3/4 xl:w-3/5 mx-auto">{children}</div>;
}

export default TemplateFrame;
